// extracted by mini-css-extract-plugin
export var heading = "P5xzwDG6_2Jo0IOaESUi";
export var introButton = "b5nCbIQ49la1p4L2g0eA";
export var introButtonDescription = "aLdgxLRFDehh_p7Nbwe1";
export var introButtonLabel = "ikXv_I1GK9LKE7en_jVy";
export var introButtonList = "bfqJCZfLpcutwOXr4YKL";
export var introButtonLogo = "IHl172cvXBwun6TULE8L";
export var introButtonLogoContainer = "vVBNoI01WfBWnj0oAMZE";
export var subheading = "P4GV5gpdTCFPmfoQPqrb";
export var subheadingBr = "cNwqNmAgzZIL3wzezdtv";